import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const mediaUrl = (path) => {
  if (!path || /^https?:\/\//i.test(path)) return path;
  return `${BACKEND_URL}${path}`;
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
